<template>
  <table class="d-table marg-1-bottom d-table__overview" v-if="visibleCategories.length > 0">
    <thead>
    <tr>
      <th><h4>Puljer</h4></th>
      <th class="is-number" style="width: 70%">{{ $t('vue2.assign_users_hours.assigned') }}</th>
      <th class="is-number" v-if="isShowScheduled">{{ $t('vue2.assign_users_hours.scheduled') }}</th>
      <th class="is-number" v-if="isShowScheduled">{{ $t('vue2.assign_users_hours.diff') }}</th>
    </tr>
    </thead>
    <tbody>
    <UserTasksOverviewOwnPoolsPool
      v-for="taskCategory in visibleCategories"
      :taskCategory="taskCategory"
      :isShowScheduled="isShowScheduled"
      :is-date-interval-changed="isDateIntervalChanged">
    </UserTasksOverviewOwnPoolsPool>
    </tbody>
  </table>
</template>

<script>
import UserTasksOverviewOwnPoolsPool from './UserTasksOverviewOwnPoolsPool.vue'

export default {
  components: {UserTasksOverviewOwnPoolsPool},
  props: {
    isShowScheduled: {
      default: false
    },
    isDateIntervalChanged: {
      default: false
    },
    schoolSettingShownOwnPools: {
      default: () => []
    },
    userTasks: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visibleCategories () {
      return this.userTasks.filter(tasks => this.schoolSettingShownOwnPools.includes(tasks.title))
    }
  }
}
</script>

<style scoped>
.is-number {
  text-align: right;
}


.d-table, .subjects-and-tasks {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.d-table__overview {
  font-size: 10px;
}

@media only screen and (min-width: 500px) {
  .d-table__overview {
    font-size: 1rem;
  }
}

.d-table__overview tbody tr {
  border: 1px solid #e2e8f0;
}

.d-table__overview tbody tr:nth-child(even) {
  background-color: #f8fafb;
}

.d-table__overview tbody tr td {
  padding: 0.25rem;
}

.d-table__overview tbody tr td:first-child {
  padding: 0.25rem;
}

.d-table__overview tbody tr td:nth-child(4) {
  padding-right: 1rem;
}

</style>



// WEBPACK FOOTER //
// UserTasksOverviewOwnPools.vue?1fa15564